import type { TicketPerson } from '@easyhelp/shared';

/** Etichetta di un ticket senza responsabile, in evidenza nella coda (PRD-004 US-1). */
export const UNASSIGNED_LABEL = 'Non assegnato';

/** Nome leggibile di un membro; chi non è più in anagrafica è dichiarato, non inventato. */
export function personName(person: TicketPerson): string {
  return person.name ?? 'Membro non più nel team';
}

/** Collaboratori in una riga: «con Luigi, Daniele»; vuoto se non ce ne sono (DEC-004). */
export function collaboratorsLabel(collaborators: readonly TicketPerson[]): string {
  return collaborators.length === 0 ? '' : `con ${collaborators.map(personName).join(', ')}`;
}
